/** Shared viewport clamping for portaled battle HUD tooltips (rank badge, mobile layer). */

export const BATTLE_TOOLTIP_VIEWPORT_PAD_PX = 8;
export const BATTLE_TOOLTIP_ANCHOR_GAP_PX = 8;

/**
 * @param {DOMRectReadOnly} anchorRect
 * @param {number} tipWidth
 * @param {number} tipHeight
 * @param {{ preferBottom?: boolean, pad?: number, gap?: number, viewportWidth?: number, viewportHeight?: number }} [opts]
 * @returns {{ left: number, top: number }}
 */
export function computeBattleTooltipPlacement(
  anchorRect,
  tipWidth,
  tipHeight,
  {
    preferBottom = false,
    pad = BATTLE_TOOLTIP_VIEWPORT_PAD_PX,
    gap = BATTLE_TOOLTIP_ANCHOR_GAP_PX,
    viewportWidth,
    viewportHeight,
  } = {}
) {
  if (!anchorRect || typeof anchorRect !== 'object') {
    throw new Error('computeBattleTooltipPlacement: anchorRect is required');
  }
  if (!Number.isFinite(tipWidth) || tipWidth <= 0) {
    throw new Error('computeBattleTooltipPlacement: tipWidth must be a positive number');
  }
  if (!Number.isFinite(tipHeight) || tipHeight <= 0) {
    throw new Error('computeBattleTooltipPlacement: tipHeight must be a positive number');
  }

  const vw =
    viewportWidth != null
      ? viewportWidth
      : typeof window !== 'undefined'
        ? window.innerWidth
        : 1920;
  const vh =
    viewportHeight != null
      ? viewportHeight
      : typeof window !== 'undefined'
        ? window.innerHeight
        : 1080;

  const centerX = anchorRect.left + anchorRect.width / 2;
  const halfWidth = tipWidth / 2;
  let left = centerX;
  if (left - halfWidth < pad) {
    left = pad + halfWidth;
  } else if (left + halfWidth > vw - pad) {
    left = vw - pad - halfWidth;
  }

  const aboveTop = anchorRect.top - gap - tipHeight;
  const belowTop = anchorRect.bottom + gap;
  const fitsAbove = aboveTop >= pad;
  const fitsBelow = belowTop + tipHeight <= vh - pad;

  let top;
  if (preferBottom) {
    top = fitsBelow ? belowTop : fitsAbove ? aboveTop : Math.max(pad, vh - pad - tipHeight);
  } else {
    top = fitsAbove ? aboveTop : fitsBelow ? belowTop : Math.max(pad, vh - pad - tipHeight);
  }

  return { left, top };
}
